'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AdminController from './admin.controller';

export default angular.module('logServerApp.admin', ['logServerApp.auth', 'ui.router'])
  .config(routes)
  .controller('AdminController', AdminController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.js